/**
 * Маппинг data-атрибутов на CSS custom properties
 * Позволяет передавать стилевые параметры через data-атрибуты iframe
 */
const DATA_ATTR_MAPPING = {
  // Colors
  'primary-color': '--theme-primary',
  'primary-hover': '--theme-primary-hover',
  'accent-color': '--theme-accent',
  'bg-color': '--theme-bg-primary',
  'text-color': '--theme-text-primary',
  'special-offers-color': '--theme-special-offers',

  // Typography
  'font-family': '--theme-font-family',
  'font-size': '--theme-font-size-base',

  // Borders & Radius
  'border-radius': '--radius',
  'card-radius': '--theme-card-radius',
  'button-radius': '--theme-button-radius',

  // Spacing
  'spacing-sm': '--theme-spacing-sm',
  'spacing-md': '--theme-spacing-md',
  'spacing-lg': '--theme-spacing-lg',
};

/**
 * Получить стилевые параметры из data-атрибутов родительского iframe
 *
 * @returns {Object} Объект с CSS переменными и их значениями
 *
 * @example
 * // HTML: <iframe data-primary-color="#FF5733" data-font-family="Arial"></iframe>
 * const theme = getThemeFromParentIframe();
 * // {
 * //   '--theme-primary': '#FF5733',
 * //   '--theme-font-family': 'Arial'
 * // }
 */
export const getThemeFromParentIframe = () => {
  const theme = {};
  let hasThemeParams = false;

  try {
    // window.frameElement доступен только если:
    // 1. Мы внутри iframe
    // 2. Родительское окно в том же origin (same-origin policy)
    const iframeElement = window.frameElement;

    if (!iframeElement) {
      // Не в iframe или cross-origin
      return theme;
    }

    // Проходим по всем поддерживаемым data-атрибутам
    Object.entries(DATA_ATTR_MAPPING).forEach(([dataAttr, cssVarName]) => {
      // data-primary-color становится dataset.primaryColor
      const camelCaseAttr = dataAttr.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
      const value = iframeElement.dataset[camelCaseAttr];

      if (value) {
        theme[cssVarName] = value;
        hasThemeParams = true;
      }
    });

    // Логируем только если есть стилевые параметры
    if (hasThemeParams) {
      console.log('[iframeDataAttributes] Theme parameters from iframe data-attributes:', theme);
    }
  } catch (error) {
    // Cross-origin ошибка или браузер не поддерживает window.frameElement
    console.log('[iframeDataAttributes] Cannot access parent iframe (possibly cross-origin):', error.message);
  }

  return theme;
};
